const SilverBase = require('silver-base');

/**
 * SilverContainerEvent
 * @class
 */
class SilverContainerEvent extends SilverBase {
  constructor(opt) {
    super(opt);
    this.isDone = false
  }

  init(opt) {
    if (this.isDone) {
      return this
    }
    this.isDone = true;
    let auto = true;
    if (opt) {
      auto = opt.auto === undefined ? true : !!opt.auto;
    }
    if (auto) {
      this.openKey();
      this.openDownload();
    }
    this.openLogin();
    this.setEvent();
    this.setResume();
    this.setPause();
  }

  /**
   * getName 获取组件名称
   * @memberOf SilverEvent.prototype
   * @method getName
   * @return {String}
   */
  getName() {
    return 'SilverEvent';
  }

  openLogin() {
    window.tv && window.tv.signEvent && window.tv.signEvent('onNewactivityLoginState', 1);
    return this;
  }


  /**
   * 特殊按键
   */
  openKey() {
    if (window.tv) {
      window.tv.signEvent && window.tv.signEvent('onNewactivityKeyEvent', 1);
      if (window.tv.specialKeyClick) {
        window.tv.specialKeyClick('VolumeUp', true);
        window.tv.specialKeyClick('VolumeDown', true);
        window.tv.specialKeyClick('VolumeMute', true);
        window.tv.specialKeyClick('M', true);
        window.tv.specialKeyClick('HomeKey', true);
        window.tv.specialKeyClick('Menu', true);
      }
    }
    return this;
  }

  /**
   * 下载事件
   * @returns {SilverEvent}
   */
  openDownload() {
    window.tv && window.tv.signEvent && window.tv.signEvent('onNewactivityAppUpdateState', 1);
    return this;
  }

  /**
   * 事件监听回调统一入口
   */
  setEvent() {
    if (window.onFireEvent) {
      return;
    }
    window.onFireEvent = function (eventname, eventdata) {
      if (typeof eventdata === 'string') {
        try {
          eventdata = JSON.parse(eventdata)
        } catch (e) {
          eventdata = {ret: ['JS_ERR::PARAM_PARSE_ERROR']};
        }
      }
      let eventType = '';
      switch(eventname) {
        case 'onNewactivityKeyEvent':
          const keyName = eventdata.keyName;
          const keyAction = eventdata.keyAction;
          if (keyAction === 0) {
            eventType = keyName + 'KeyDown';
          } else {
            eventType = keyName + 'KeyUp';
          }
          break
        case 'onNewactivityAppUpdateState':
          eventType = 'download'
          break
        case 'onNewactivityLoginState':
          const accountType = eventdata.accountType
          const loginState = eventdata.loginState
          if (accountType === 1) {
            if (loginState) {
              eventType = 'tbLogin'
            } else {
              eventType = 'tbLoginOut'
            }
          } else {
            if (loginState) {
              eventType = 'ykLogin'
            } else {
              eventType = 'ykLoginOut'
            }
          }
          break
      }
      let ev = window.document.createEvent('HTMLEvents');
      ev.initEvent(eventType, true, true);
      ev.eventType = eventType;
      ev.param = eventdata;
      window.document.dispatchEvent(ev);
    }
  }

  /**
   * 设置当页面恢复（onResume）时调用javascript的方法，从后台调入前台
   * func表示回调的javascript的方法，没有参数
   */
  setResume() {
    if (window.tv && window.tv.setOnResumeFunc) {
      window.tv.setOnResumeFunc('__onResume__');
      const eventType = 'resume';
      window.__onResume__ = function () {
        let ev = window.document.createEvent('HTMLEvents');
        ev.initEvent(eventType, true, true);
        ev.eventType = eventType;
        ev.param = {};
        window.document.dispatchEvent(ev);
      }
    }
  }

  /**
   * 设置当页面暂停（onPause）时调用javascript的方法，从前台调入后台
   * 参数：func表示回调的javascript的方法，没有参数
   */
  setPause() {
    if (window.tv && window.tv.setOnPauseFunc) {
      window.tv.setOnPauseFunc('__onPause__');
      const eventType = 'pause';
      window.__onPause__ = function () {
        let ev = window.document.createEvent('HTMLEvents');
        ev.initEvent(eventType, true, true);
        ev.eventType = eventType;
        ev.param = {};
        window.document.dispatchEvent(ev);
      }
    }
  }
}

export const SilverEvent = new SilverContainerEvent();



// WEBPACK FOOTER //
// ./~/@ali/silver-event/lib/index.js